<div class="page-container">
    <div class="landing">
        <!-- what LINQ is, beside the sign in card -->
        <section class="pitch">
            <img class="logo" [src]="IMAGE_LINQ" alt="LINQ" height="44"/>
            <h1>LINQ is your business modelling platform</h1>
            <p class="lead">Model your business processes visually, uncover inefficiencies and optimise for time, cost, capacity and
                carbon, all in one platform.</p>
            @if (!app.smallScreen) {
                <ul class="benefits">
                    <li><mat-icon aria-hidden="true">account_tree</mat-icon><span>Map processes, people and systems in one model</span></li>
                    <li><mat-icon aria-hidden="true">insights</mat-icon><span>See where time, cost, capacity and carbon go</span></li>
                    <li><mat-icon aria-hidden="true">compare_arrows</mat-icon><span>Plan future states and compare them with today</span></li>
                </ul>
            }
            <p class="free"><mat-icon aria-hidden="true">redeem</mat-icon><span>Free for a single user and up to 150 nodes, so you can see it for yourself without obligation.</span></p>

            @if (!app.smallScreen) {
                <div class="video-ring">
                    <video #videoPlayer autoplay muted loop playsinline aria-label="LINQ modelling in action">
                        <source type="video/mp4">
                    </video>
                </div>
            }
        </section>

        <section class="login-container" aria-label="Sign in or register">
            <div class="login-content">
                <h2 class="card-title">
                    @switch (selectedIndex) {
                        @case (LANDING_TAB.REGISTER) { {{code ? 'Set up your account' : 'Create your free account'}} }
                        @case (LANDING_TAB.RESET) { Reset your password }
                        @default { Welcome back }
                    }
                </h2>
                @if (linkProblem) {
                    <p class="notice error" role="alert">{{linkProblem}}</p>
                }
                @if (code && !registered) {
                    <p class="notice">You've been invited to join LINQ. Choose a password to set up your account.</p>
                }

                <mat-tab-group [(selectedIndex)]="selectedIndex" mat-stretch-tabs="true" animationDuration="0ms" [disablePagination]="true">
                    <mat-tab label="Sign in" [disabled]="code && !registered">
                        <form [formGroup]="authForm" (ngSubmit)="signIn()">
                            <div class="form-content">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <mat-icon matPrefix>email</mat-icon>
                                    <input type="email" matInput formControlName="email" autocomplete="username" id="login-email" [maxlength]="EMAIL_MAX" required>
                                    @if (authForm.controls['email'].invalid) {
                                        <mat-error>Enter a valid email address</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Password</mat-label>
                                    <mat-icon matPrefix>lock</mat-icon>
                                    <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" autocomplete="current-password" id="login-password" required>
                                    <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
                                        <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    </button>
                                    @if (authForm.controls['password'].invalid) {
                                        <mat-error>Enter your password</mat-error>
                                    }
                                </mat-form-field>

                                <button type="button" mat-button class="forgotten" (click)="selectedIndex = LANDING_TAB.RESET">Forgotten your password?</button>
                                @if (loginError) {
                                    <p class="error" role="alert">{{loginError}}</p>
                                }
                                <button type="submit" mat-flat-button color="accent" class="submit" [disabled]="signingIn">{{signingIn ? 'Signing in…' : 'Sign in'}}</button>
                            </div>
                        </form>
                        <div class="divider"><span>or sign in with</span></div>
                        <div class="social">
                            <button type="button" class="ms-button" (click)="loginMicrosoft()" aria-label="Sign in with Microsoft">
                                <img data-testid="msLoginButton" height="30" src="assets/images/ms-symbollockup_signin_light.svg" alt="Sign in with Microsoft">
                            </button>
                            <asl-google-signin-button data-testid="googleLoginButton" type='standard' size='medium'></asl-google-signin-button>
                        </div>
                        <p class="switch">New to LINQ? <button type="button" class="text-button" (click)="selectedIndex = LANDING_TAB.REGISTER">Create a free account</button></p>
                    </mat-tab>

                    <mat-tab [label]="code ? 'Set up account' : 'Register'" [disabled]="code && registered">
                        <form [formGroup]="registrationForm" (ngSubmit)="register()">
                            <div class="form-content">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <mat-icon matPrefix>email</mat-icon>
                                    <input type="email" matInput formControlName="email" autocomplete="username" id="register-email" [maxlength]="EMAIL_MAX" required>
                                    @if (code) {
                                        <mat-hint>The email your invitation was sent to</mat-hint>
                                    }
                                    @if (registrationForm.controls['email'].invalid) {
                                        <mat-error>Enter a valid email address</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Your name</mat-label>
                                    <mat-icon matPrefix>person</mat-icon>
                                    <input type="text" matInput formControlName="usersname" autocomplete="name" id="register-name" [maxlength]="USER_NAME_MAX" required>
                                    @if (registrationForm.controls['usersname'].invalid) {
                                        <mat-error>Your name must be between {{USER_NAME_MIN}} and {{USER_NAME_MAX}} characters</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Password</mat-label>
                                    <mat-icon matPrefix>lock</mat-icon>
                                    <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" autocomplete="new-password" id="register-password" [maxlength]="PASSWORD_MAX" required>
                                    <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
                                        <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    </button>
                                    <mat-hint>{{PASSWORD_MIN}} to {{PASSWORD_MAX}} characters</mat-hint>
                                    @if (registrationForm.controls['password'].invalid) {
                                        <mat-error>Password must be between {{PASSWORD_MIN}} and {{PASSWORD_MAX}} characters</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Confirm password</mat-label>
                                    <mat-icon matPrefix>lock</mat-icon>
                                    <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="passwordConfirmation" autocomplete="new-password" id="register-password-confirmation" [maxlength]="PASSWORD_MAX" required>
                                    @if (registrationForm.controls['passwordConfirmation'].hasError('required')) {
                                        <mat-error>Enter the password again</mat-error>
                                    }
                                </mat-form-field>
                                @if (passwordsDiffer()) {
                                    <p class="error" role="alert">The passwords don't match</p>
                                }

                                @if (registerError) {
                                    <p class="error" role="alert">{{registerError}}</p>
                                }
                                <button type="submit" mat-flat-button color="accent" class="submit" [disabled]="registering">
                                    {{registering ? (code ? 'Setting up…' : 'Registering…') : (code ? 'Set up account' : 'Create account')}}
                                </button>
                            </div>
                        </form>
                        @if (!code) {
                            <div class="divider"><span>or register with</span></div>
                            <div class="social">
                                <button type="button" class="ms-button" (click)="loginMicrosoft()" aria-label="Register with Microsoft">
                                    <img data-testid="msregisterButton" height="30" src="assets/images/ms-symbollockup_signin_light.svg" alt="Sign in with Microsoft">
                                </button>
                                <asl-google-signin-button type='standard' size='medium'></asl-google-signin-button>
                            </div>
                        }
                        <p class="terms">By registering you agree to the LINQ
                            <a href="https://www.thinklikelinq.com/terms-of-use/" target="_blank" rel="noopener">terms of use</a> and
                            <a href="https://www.thinklikelinq.com/privacy-policy/" target="_blank" rel="noopener">privacy policy</a>.</p>
                        @if (!code) {
                            <p class="switch">Already have an account? <button type="button" class="text-button" (click)="selectedIndex = LANDING_TAB.LOGIN">Sign in</button></p>
                        }
                    </mat-tab>

                    <mat-tab label="Reset password">
                        <form [formGroup]="resetForm" (ngSubmit)="reset()">
                            <div class="form-content">
                                <p class="tab-intro">Enter the email you sign in with and we'll send you a link to set a new password.</p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <mat-icon matPrefix>email</mat-icon>
                                    <input type="email" matInput formControlName="resetEmail" autocomplete="username" id="reset-email" [maxlength]="EMAIL_MAX" required>
                                    @if (resetForm.controls['resetEmail'].invalid) {
                                        <mat-error>Enter a valid email address</mat-error>
                                    }
                                </mat-form-field>
                                @if (resetSent) {
                                    <p class="success" role="status">If there's an account for that email, a reset link is on its way. It lasts for a limited time.</p>
                                }
                                @if (resetError) {
                                    <p class="error" role="alert">{{resetError}}</p>
                                }
                                <button type="submit" mat-flat-button color="accent" class="submit" [disabled]="resetting">{{resetting ? 'Sending…' : 'Send reset link'}}</button>
                            </div>
                        </form>
                        <p class="switch"><button type="button" class="text-button" (click)="selectedIndex = LANDING_TAB.LOGIN"><mat-icon aria-hidden="true">arrow_back</mat-icon>Back to sign in</button></p>
                    </mat-tab>
                </mat-tab-group>
                <div class="links">
                    <a href="https://www.thinklikelinq.com/terms-of-use/" target="_blank" rel="noopener">Terms of use</a>
                    <span aria-hidden="true">·</span>
                    <a href="https://www.thinklikelinq.com/privacy-policy/" target="_blank" rel="noopener">Privacy policy</a>
                </div>
            </div>
        </section>
    </div>
    <footer class="tagline">
        <span>See. Solve. Share.</span>
        <span class="tagline-sep" aria-hidden="true"></span>
        <span>Process clarity. <b>Measurable outcomes.</b></span>
    </footer>
</div>
